<template>
  <b-card no-body class="w-100 card-filter-advanced">
    <b-card-header
      header-tag="header"
      class="p-1 cursor-pointer bg-transparent d-inline-flex align-items-center border-0"
      role="tab"
      @click="toggleDisplayContent"
    >
      <h5 class="mb-0 text-exitos pr-3">
        <font-awesome-icon :icon="icon" class="mr-1" />
        {{ title }}
      </h5>
      <small v-if="description" class="text-muted">{{ description }}</small>
      <span
        class="d-inline text-sm ml-auto"
        :class="{ 'text-exitos': !isDisplayContent }"
      >
        <slot name="right" :visible="isDisplayContent"></slot>
        <small
          class="pr-1 font-weight-normal"
          v-text="isDisplayContent ? 'Recolher' : 'Expandir'"
        />
        <font-awesome-icon
          :icon="isDisplayContent ? 'chevron-up' : 'chevron-down'"
        />
      </span>
    </b-card-header>
    <b-collapse v-model="isDisplayContent">
      <b-card-body class="px-4">
        <slot />
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import { toggleValue } from "@/mixins/toggle";

export default {
  name: "CardCollapseFilter",
  mixins: [toggleValue("display content")],
  props: {
    icon: {
      type: [String, Array],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    initialVisible: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.initialVisible) this.isDisplayContent = true;
  },
};
</script>
